import React from 'react';
import Navbar from '../Layout/Navbar';
import PublicNavbar from '../Layout/PublicNavbar';
import Footer from '../Layout/Footer';
import { useAuth } from '../../contexts/AuthContext';
import SEO from '../Common/SEO';
import './Legal.css';

function PrivacyPolicy() {
  const { isAuthenticated } = useAuth();
  const updatedDate = 'January 24, 2026';

  return (
    <div className="page-wrapper">
      <SEO
        title="Privacy Policy"
        description="Options Tracker Privacy Policy - Learn how we collect, use, and protect your personal information and trading data."
        canonicalPath="/privacy"
      />
      {isAuthenticated ? <Navbar /> : <PublicNavbar />}
      <div className="container legal-page">
        <div className="page-header">
          <div>
            <h1>Privacy Policy</h1>
            <p className="page-subtitle">How we collect, use, and protect your information.</p>
            <div className="legal-updated">Last updated: {updatedDate}</div>
          </div>
        </div>

        <h2>Information We Collect</h2>
        <ul>
          <li>Account information such as name and email address</li>
          <li>Trade and portfolio data you enter into the platform</li>
          <li>Technical data such as IP address and browser details for security</li>
        </ul>

        <h2>How We Use Your Information</h2>
        <ul>
          <li>To provide and maintain the service</li>
          <li>To personalize your experience and analytics</li>
          <li>To communicate account and subscription updates</li>
          <li>To improve product performance and security</li>
        </ul>

        <h2>Payments</h2>
        <p>
          Subscription payments are processed by Stripe. We do not store or have access to your full payment card details.
        </p>

        <h2>Data Retention</h2>
        <p>
          We retain your data for as long as your account is active. You may request deletion of your account and data at
          any time.
        </p>

        <h2>Cookies</h2>
        <p>
          We use cookies and similar technologies to operate and improve the service:
        </p>
        <ul>
          <li><strong>Essential cookies:</strong> Required for authentication, security, and remembering your preferences (e.g., dark mode).</li>
          <li><strong>Analytics cookies:</strong> Used to understand how visitors interact with the site. These are only enabled if you consent via the cookie banner.</li>
        </ul>
        <p>
          You can manage your cookie preferences at any time by clearing your browser cookies and revisiting the site.
        </p>

        <h2>Third-Party Services</h2>
        <p>
          We use third-party services for email delivery, analytics, and market data. These providers may process data
          on our behalf under their own privacy policies.
        </p>

        <h2>Security</h2>
        <p>
          We take reasonable measures to protect your information but cannot guarantee absolute security.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Changes will be posted on this page.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy questions, contact
          {' '}
          <a href="mailto:options.tracker.email.verify@gmail.com?subject=Privacy%20Policy">
            options.tracker.email.verify@gmail.com
          </a>
          .
        </p>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;

